/* import __COLOCATED_TEMPLATE__ from './single-trigger.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export interface IArgs {
  value?: string | number;
  class?: string;
  disabled?: boolean;
  autoFocus: boolean;
  onInput?: (event?: InputEvent) => void;
  onClear?: (event: MouseEvent) => void;
}

interface SingleTriggerSignature {
  Args: IArgs;
  Element: HTMLElement;
}

export default class SingleTrigger extends Component<SingleTriggerSignature> {
  @action
  onChange(_value: string | number, _id: string, event?: InputEvent) {
    this.args.onInput?.(event);
  }

  @action
  onClear(_id: string, event: MouseEvent) {
    this.args.onClear?.(event);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvSelectCreate::SingleTrigger': typeof SingleTrigger;
    'bv-select-create/single-trigger': typeof SingleTrigger;
  }
}
